import AsyncSelect from "react-select/async";
import ReactSelect from "react-select";

// react-select ships its own blue (#2684FF) for the focused control and the
// highlighted option, which clashed with the green fields around it. This wraps
// it with the brand green. COLOURS ONLY: react-select's geometry (height,
// radius, min-width) is left alone, unlike the .cf-rs skin in
// styles/_react-select.scss which is sized for the filter bar.
// JS twin of $green-deep in styles/_tokens.scss, kept in sync by hand.
const GREEN_DEEP = "#81b23d";

export const cfSelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    // ponytail: `primary` paints the focused border AND the selected option's
    // background, whose label react-select draws with `neutral0` - the same
    // token as the menu and control background, so the theme cannot darken
    // that label alone (white on green sits at 2.5:1). Upgrade path: a
    // `styles.option` override, added per usage since 6 already pass `styles`.
    primary: GREEN_DEEP,
    primary50: "rgba(129, 178, 61, 0.16)", // option being clicked
    primary25: "rgba(129, 178, 61, 0.09)", // option under the cursor
  },
});

// `theme` sits before the spread so a caller can still pass its own.
export const CfSelect = (props) => (
  <ReactSelect theme={cfSelectTheme} {...props} />
);

// Same, for options loaded as the user types
export const CfAsyncSelect = (props) => (
  <AsyncSelect theme={cfSelectTheme} {...props} />
);
